import React from 'react';
import PropTypes from 'prop-types';

// import context
import { useRecipeFilterContext } from '@/context/recipeFilter';

// import hooks
import useRecipeFilterLoad from '@/hooks/recipe/useRecipeFilterLoad';
import useRecipeBrowseByLoad from '@/hooks/recipe/useRecipeBrowseByLoad';
import useRecipeFilterChangeQuery from '@/hooks/recipe/useRecipeFilterChangeQuery';
import useRecipeFilterPopstate from '@/hooks/recipe/useRecipeFilterPopstate';
import useRecipePagination from '@/hooks/recipe/useRecipePagination';

// import components
import ServiceFilter from '@/components/organisms/ServiceFilter';
import RecipeBrowseBy from '@/components/organisms/Recipe/RecipeBrowseBy';

const RecipeFilterApp = ({ hasLoadMore, browseBy, title, subtitle }) => {
  const [
    { filters },
    { applyFilter, clearFilters, applySort },
  ] = useRecipeFilterContext();

  // hooks
  useRecipeFilterLoad({ hasLoadMore, browseBy });
  useRecipeBrowseByLoad(browseBy);
  useRecipeFilterChangeQuery();
  useRecipeFilterPopstate();
  useRecipePagination();

  const hasResults = filters && filters.count > 0;

  return (
    <>
      <RecipeBrowseBy title={title} subtitle={subtitle} />
      {hasResults && (
        <div className='dln-filters-bar'>
          <ServiceFilter
            filters={filters}
            showCount
            onApplyFilter={applyFilter}
            onClearFilters={clearFilters}
            onApplySort={applySort}
          />
        </div>
      )}
    </>
  );
};

RecipeFilterApp.propTypes = {
  hasLoadMore: PropTypes.string.isRequired,
  browseBy: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

RecipeFilterApp.defaultProps = {
  browseBy: null,
  title: null,
  subtitle: null,
};

export default RecipeFilterApp;
